import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Alert, Typography } from '@mui/material';
import { useAuth } from '../context/AuthContext';

interface ProfileCompletionDialogProps {
	open: boolean;
}

export const ProfileCompletionDialog: React.FC<ProfileCompletionDialogProps> = ({ open }) => {
	const { updateProfile } = useAuth();
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [error, setError] = useState<string | null>(null);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleSubmit = async (event: React.FormEvent) => {
		event.preventDefault();
		setError(null);

		if (!firstName.trim() || !lastName.trim()) {
			setError('First and last name are required.');
			return;
		}

		setIsSubmitting(true);
		try {
			await updateProfile(firstName, lastName);
		} catch (err) {
			setError(err instanceof Error ? err.message : 'Failed to update profile');
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<Dialog open={open} fullWidth maxWidth="sm" disableEscapeKeyDown>
			<DialogTitle>Complete your profile</DialogTitle>
			<DialogContent>
				<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
					Please enter your name to continue.
				</Typography>
				<form onSubmit={handleSubmit}>
					<TextField
						label="First Name"
						value={firstName}
						onChange={(e) => setFirstName(e.target.value)}
						fullWidth
						required
						margin="dense"
					/>
					<TextField
						label="Last Name"
						value={lastName}
						onChange={(e) => setLastName(e.target.value)}
						fullWidth
						required
						margin="dense"
					/>
					{error && (
						<Alert severity="error" sx={{ mt: 2 }}>
							{error}
						</Alert>
					)}
					<DialogActions sx={{ px: 0, pt: 3 }}>
						<Button type="submit" variant="contained" disabled={isSubmitting}>
							{isSubmitting ? 'Saving...' : 'Save'}
						</Button>
					</DialogActions>
				</form>
			</DialogContent>
		</Dialog>
	);
};
